import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { RecurringZoomMeetingsFormVM } from './recurring-zoom-meetings-form.viewmodel';
import { RecurringZoomMeetingsFormPresentation } from './recurring-zoom-meetings-form.presentation';

interface IProps {
    vm: RecurringZoomMeetingsFormVM;
}

const RecurringZoomMeetingsFormContainer = withViewModel(
  RecurringZoomMeetingsFormPresentation,
    (props: IProps) => {
        return props.vm;
    }
);

export { RecurringZoomMeetingsFormContainer as RecurringZoomMeetingsForm };
